export default __webpack_public_path__ + "static/media/delegates__cards-list-item-icon-5.82719992.svg";